import React, { useState } from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
import Input from '~/form_components/text_input';
const RenameProject = (props) => {
    const { isVisible, onHide, handleRenameProject, selectedProject } = props;
    const [newName, setNewName] = useState();
    const handleRename = () => {
        if (newName === null || newName === void 0 ? void 0 : newName.trim()) {
            handleRenameProject(newName.trim());
            onHide();
        }
    };
    return (React.createElement(GeniusModal, { isModalShowing: isVisible, alertForm: true, onHide: () => { setNewName(undefined); onHide(); }, bodyContent: React.createElement(React.Fragment, null,
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Location' }, "Rename folder"),
            React.createElement("div", { className: 'rename-modal-text-input' },
                React.createElement(Input, { name: 'rename', value: newName, placeholder: selectedProject.name, onChange: (e) => setNewName(e.target.value) }))), footerContent: React.createElement(Button, { className: 'modal-action-btn', primary: true, onClick: handleRename, disabled: !(newName === null || newName === void 0 ? void 0 : newName.trim()) }, "Rename") }));
};
export default RenameProject;
